class LinkDropdown extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('#filter-by');
    this.blogUrl = this.select.dataset.blogUrl;
    this.initialValue = this.select.value;
    this.pointerChange = false;

    // YBTCO: navigate straight away for mouse/touch picks, but let keyboard
    // users arrow through options and go on Enter or when leaving the menu
    // (WCAG 3.2.2: arrow keys fire `change` on a closed select on Windows).
    this.select.addEventListener('pointerdown', () => { this.pointerChange = true; });
    this.select.addEventListener('keydown', this.onKeydown.bind(this));
    this.select.addEventListener('change', this.onSelectChange.bind(this));
    this.select.addEventListener('blur', this.onBlur.bind(this));
  }

  onKeydown(event) {
    this.pointerChange = false;
    if (event.key === 'Enter') {
      event.preventDefault();
      this.navigate();
    }
  }

  onSelectChange() {
    if (this.pointerChange) this.navigate();
  }

  onBlur() {
    if (this.select.value !== this.initialValue) this.navigate();
  }

  navigate() {
    if (this.select.value.length > 0) {
      window.location.href = this.blogUrl + '/tagged/' + encodeURIComponent(this.select.value);
    }
    else window.location.href = this.blogUrl;
  }
}

customElements.define("link-dropdown", LinkDropdown);
